import Transport from '../../common/services/api/Transport';

const transport = new Transport();

const registeredToken = localStorage.getItem('token');
if (registeredToken) {
    transport.rememberToken(registeredToken);
}

export const logUserIn = async data => {
    try {
        const result = await transport.post({ path: `users/login`, data });
        if (result.data.statusCode === 200) {
            const registeredToken = result.data.data.token;
            if (result.data.data.token) {
                transport.rememberToken(registeredToken);
            }
        }

        return result.data.statusCode === 200 ? result.data.data.token : null;
    } catch (error) {
        return null;
    }
};

export const authorizeUser = async () => {
    try {
        const result = await transport.get({ path: `users/authorize` });
        if (result.data.statusCode !== 200 || !result.data.data) {
            return null;
        }

        const user = result.data.data;
        return user._id || user.fullname ? user : null;
    } catch (error) {
        return null;
    }
};
